import { useSearchParams } from 'react-router-dom';

const ON_VALUES = new Set(['1', 'true', 'on', 'yes']);

export function useRequestQueue() {
  const [searchParams] = useSearchParams();
  const raw = (searchParams.get('requests') || '').toLowerCase();
  const requestsEnabled = ON_VALUES.has(raw);

  // Only the requests flag follows the user between tabs; a search's `?q=`
  // belongs to the Ask tab alone.
  const querySuffix = requestsEnabled ? `?requests=${searchParams.get('requests')}` : '';

  return {
    requestsEnabled,
    withParams: (path) => `${path}${querySuffix}`,
  };
}
